import { Fragment } from 'react'
import { housingComfort } from '../utils/structures'
import '../styles/ConstructionConfirmModal.css'

const ConstructionConfirmModal = ({ region, constructionSelection, housingOptions, cost, lngLat, onConfirm, onCancel }) => {
  if (!region || !constructionSelection) return null

  const { type, specialisation, level } = constructionSelection
  const specLabel = specialisation && specialisation !== 'NA' ? ` — ${specialisation}` : ''

  // Housing has no level: it is a density × style × quality × capacity combo.
  const isHousing = type === 'Logement'
  const isPowerPlant = type === 'Centrale électrique'
  const named = (list, id) => housingOptions?.[list]?.find((o) => o.id === id)?.name ?? '—'
  const comfort = isHousing ? housingComfort(housingOptions, constructionSelection) : null

  return (
    <Fragment>
      <div className="modal-backdrop" onClick={onCancel} />
      <div className="construction-modal">
        <h3>Confirmation de construction</h3>

        <div className="modal-details">
          <div className="detail-row">
            <span className="detail-label">Région</span>
            <span className="detail-value">#{region.region_id} — {region.name}</span>
          </div>
          {isHousing ? (
            <>
              <div className="detail-row">
                <span className="detail-label">Structure</span>
                <span className="detail-value">Logement</span>
              </div>
              <div className="detail-row">
                <span className="detail-label">Capacité</span>
                <span className="detail-value">{Number(constructionSelection.capacity || 0).toLocaleString('fr-FR')} habitants</span>
              </div>
              <div className="detail-row">
                <span className="detail-label">Densité</span>
                <span className="detail-value">{named('densities', constructionSelection.density_id)}</span>
              </div>
              <div className="detail-row">
                <span className="detail-label">Style</span>
                <span className="detail-value">{named('styles', constructionSelection.style_id)}</span>
              </div>
              <div className="detail-row">
                <span className="detail-label">Qualité</span>
                <span className="detail-value">{named('qualities', constructionSelection.quality_id)}</span>
              </div>
              <div className="detail-row">
                <span className="detail-label">Confort</span>
                <span className="detail-value">{comfort ?? '—'}/100</span>
              </div>
            </>
          ) : isPowerPlant ? (
            <div className="detail-row">
              <span className="detail-label">Centrale</span>
              <span className="detail-value">{constructionSelection.power_type || '—'} niv.{level}</span>
            </div>
          ) : (
            <div className="detail-row">
              <span className="detail-label">Structure</span>
              <span className="detail-value">{type}{specLabel} niv.{level}</span>
            </div>
          )}
          <div className="detail-row">
            <span className="detail-label">Position</span>
            <span className="detail-value">{lngLat.lat.toFixed(4)}, {lngLat.lng.toFixed(4)}</span>
          </div>
          <div className="detail-row cost-row">
            <span className="detail-label">Coût</span>
            <span className="detail-value">{Number(cost).toLocaleString('fr-FR')} crédits</span>
          </div>
        </div>

        <div className="modal-actions">
          <button className="btn-cancel" onClick={onCancel}>Annuler</button>
          <button className="btn-confirm" onClick={onConfirm}>Construire</button>
        </div>
      </div>
    </Fragment>
  )
}

export default ConstructionConfirmModal
